import ExternalSociety from "./ExternalSociety";
import UserProfile from "./UserProfile";
import { ROLES } from "@/utils/users";
import { camelToSnakeDeep } from "@/utils/utilsGrcpRest";

export default class ProjectRole {
  constructor(projectRole) {
    this.setData(projectRole);
  }

  setData(projectRole) {
    const { userProfile, externalSociety, ...roleData } = projectRole ?? {};
    const defaultValue = {
      uuid: null,
      role: null,
      projectPhoneNumber: "",
      projectContributorFirstName: "",
      projectContributorLastName: "",
      mandatoryRecipient: false,
      externalRole: null,
      projectHierarchicalRole: null,
    };
    const definedData = Object.fromEntries(
      Object.entries(roleData).filter(([, value]) => value !== undefined),
    );

    Object.assign(this, defaultValue, definedData);
    this.userProfile = new UserProfile(userProfile);
    this.externalSociety = new ExternalSociety(externalSociety);
  }

  getProjectRole() {
    // setProjectInformations is user is dev so we need to double check here
    if (this.isDevOrSuperUser()) {
      return ROLES.DEVELOPER;
    } else {
      return this.role;
    }
  }

  getDisplayName() {
    // is external implicitly (if is from Socotec, projectContributorFirstName is not defined)
    if (this.projectContributorFirstName || this.projectContributorLastName) {
      return `${this.projectContributorFirstName} ${this.projectContributorLastName}`;
    }
    if (this.userProfile.first_name) {
      return `${this.userProfile.first_name} ${this.userProfile.last_name}`;
    }

    return this.userProfile.email;
  }

  getDisplayInitials() {
    try {
      const firstName = this.projectContributorFirstName || this.userProfile.first_name;
      const lastName = this.projectContributorLastName || this.userProfile.last_name;
      return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
    } catch {
      return this.userProfile.email.charAt(0).toUpperCase();
    }
  }

  toUserProfileInput() {
    return {
      email: this.userProfile.email,
      firstName: this.userProfile.first_name,
      lastName: this.userProfile.last_name,
      telephoneNumber: this.userProfile.telephone_number,
      jobTitle: this.userProfile.job_title,
      signature: this.userProfile.signature,
      language: this.userProfile.language,
      isMultiLanguageActivated: this.userProfile.is_multi_language_activated,
    };
  }

  toExternalSocietyInput() {
    const { uuid, ...society } = this.externalSociety;
    return uuid ? { uuid, ...society } : society;
  }

  toWriteRequest() {
    return {
      role: this.role,
      externalRole: this.externalRole,
      projectPhoneNumber: this.projectPhoneNumber,
      projectContributorFirstName: this.projectContributorFirstName,
      projectContributorLastName: this.projectContributorLastName,
      mandatoryRecipient: this.mandatoryRecipient,
      userProfile: this.toUserProfileInput(),
      externalSociety: this.toExternalSocietyInput(),
    };
  }

  // L.B 25/09/26 la webmail, hors de ce dépôt, lit les destinataires dans la forme
  // envoyée par la 8.11.15 : tout en snake_case, user_profile compris.
  toWebmailPayload() {
    const { userProfile, externalSociety, ...roleData } = this;
    return {
      ...camelToSnakeDeep(roleData),
      user_profile: userProfile,
      external_society: externalSociety.toWebmailPayload(),
    };
  }
}
